export const ratingFeedbackData = [
    {
        text: "Rating is displayed using ",
        code: "step={5}",
    },
    {
        text: " in react-rating package",
    },
];

export const pillRatingData = [
    {
        text: "Pill rating is displayed using ",
        code: ".pill-rating",
    },
    {
        text: " class",
    },
];

export const reverseRatingData = [
    {
        text: "Reversed rating is displayed using ",
        code: 'direction="rtl"'
    },
    {
        text: ' Attribute in Rating.'
    }
]

export const starRatingData = [
    {
        text: "Star rating is displayed using ",
        code: '.fa-regular fa-star & fa-solid fa-star'
    },
    {
        text: ' class in rating symbol'
    }
]

export const thumbUpDownData = [
    {
        text: "Thumb rating is displayed using ",
        code: '.fa-thumbs-up & .fa-thumbs-down'
    },
    {
        text: ' class in rating symbol'
    }
]
